// Texty lišty kategorií a mega menu — slovenské dvojče locale/cs/megaMenu.js.

export default {
  labelAll: 'Všetky kategórie',
  labelRest: 'Ďalšie kategórie',
  saleChip: 'Zľavy',
  cta: {
    garden: 'Všetko zo Záhrady →',
    build: 'Všetko zo Stavby →',
    workshop: 'Všetko z Dielne →',
    home: 'Všetko z Domácnosti →',
    kids: 'Všetko pre deti →',
  },
  ctaFallback: (label) => 'Všetko z kategórie ' + label + ' →',
  promo: {
    garden: { badge: 'AKCIA TÝŽDŇA', title: 'Záhradná technika v akcii' },
    build: { badge: 'SKLADOM', title: 'Stavebná technika skladom' },
    workshop: { badge: 'TIP', title: 'Vybavte si dielňu' },
    home: { badge: 'NOVINKA', title: 'Ventilátory Boxer skladom' },
    kids: { badge: 'SEZÓNA', title: 'Šmykľavky a hojdačky na záhradu' },
    car: { badge: 'PRE VODIČOV', title: 'Výbava do každého auta' },
    xmas: { badge: 'SEZÓNA', title: 'Vianočné osvetlenie a dekorácie' },
    ppe: { badge: 'BEZPEČNOSŤ', title: 'Ochranné pomôcky pri práci' },
    solar: { badge: 'ÚSPORY', title: 'Solárna technika pre dom' },
    clearance: { badge: 'VÝPREDAJ', title: 'Výpredaj skladu so zľavou' },
  },
};
